module.exports = __webpack_public_path__ + "static/media/barberscape-replacement-blade-5.ec767ca2.png";